import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import zh from './zh.json';

const messages = {
  en: en,
  fr: fr,
  es: es,
  zh: zh
};

export default messages;
